import { create } from "zustand";

export interface Note {
  id: string;
  title: string;
  body: string;
  time: string;
  read: boolean;
}

/* API wiring point: replace with your notifications endpoint. */
export const SEED_NOTES: Note[] = [
  { id: "n1", title: "Leave request approved", body: "Your leave for 3 Nov was approved.", time: "5 min ago", read: false },
  { id: "n2", title: "New task assigned", body: "Review Q4 payroll summary.", time: "1 hr ago", read: false },
  { id: "n3", title: "Invoice paid", body: "INV-1042 was settled by Lagos Plaza.", time: "Yesterday", read: false },
  { id: "n4", title: "Meeting moved", body: "Research Morning Meeting is now 10:30.", time: "Yesterday", read: true },
];

interface NotificationsState {
  notes: Note[];
  setNotes: (notes: Note[]) => void;
  add: (note: Note) => void;
  markRead: (id: string) => void;
  markUnread: (id: string) => void;
  markAllRead: () => void;
  remove: (id: string) => void;
  clear: () => void;
}

/**
 * One shared list for the bell dropdown in the header and the full
 * Notifications page, so reading a notification in one place updates the other.
 */
export const useNotifications = create<NotificationsState>((set) => ({
  notes: SEED_NOTES,
  setNotes: (notes) => set({ notes }),
  add: (note) => set((s) => ({ notes: [note, ...s.notes] })),
  markRead: (id) =>
    set((s) => ({ notes: s.notes.map((n) => (n.id === id ? { ...n, read: true } : n)) })),
  markUnread: (id) =>
    set((s) => ({ notes: s.notes.map((n) => (n.id === id ? { ...n, read: false } : n)) })),
  markAllRead: () => set((s) => ({ notes: s.notes.map((n) => ({ ...n, read: true })) })),
  remove: (id) => set((s) => ({ notes: s.notes.filter((n) => n.id !== id) })),
  clear: () => set({ notes: [] }),
}));